import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';
import { GlobalServices } from './global.service';

@Injectable({
    providedIn: 'root'
  })
  export class WorkspaceService {

    constructor(private http: HttpServices) { }

    public getNotificationsCount (userName: string, userId: string, isAdmin: boolean) 
    {
        return this.http.get('Notifications/GetUserNotifications?userName=' + userName + '&userId=' + userId + '&isAdmin=' + isAdmin);
    }
    public GetCircularDirectoryNotifications (userName: string, userId: string, isAdmin: boolean, CircularLookupId : number) 
    {
        return this.http.get('Notifications/GetCircularDirectoryNotifications?userName=' + userName + '&userId=' + userId + '&isAdmin=' + isAdmin +'&CircularLookupId=' + CircularLookupId);
    }
  }